import { lazy } from "react";
import { RoutesLink } from "@/utility/RouteLinks";
import { permissionKeys } from "@/utility/helper";
import type { IPrivateRoutes } from "../types";

const SuperAdminDashboard = lazy(() => import("@/pages/HRMS/Dashboard/SuperAdminDashboard"));
const UserDashboard = lazy(() => import("@/pages/Dashboard/UserDashboard"));
const Notification = lazy(() => import("@/pages/HRMS/Notification/Notification"));
const Holiday = lazy(() => import("@/pages/HRMS/HrmsSettings/HolidaySettings/Holiday"));
const Profile = lazy(() => import("@/pages/HRMS/Profile/Profile"));
const Organisation = lazy(() => import("@/pages/HRMS/Organisation/Organisation"));

export const dashboardRoutes: IPrivateRoutes[] = [
    {
        path: RoutesLink.superAdminDashboard,
        route: <SuperAdminDashboard />,
    },
    {
        path: RoutesLink.userDashboard,
        route: <UserDashboard />,
    },
    {
        path: RoutesLink.notification,
        route: <Notification />,
    },
    {
        path: RoutesLink?.holidayList,
        route: <Holiday isAdmin={false} />,
    },
    {
        path: RoutesLink.profile,
        route: <Profile />,
    },
    {
        path: RoutesLink.superAdminOrganisation,
        route: <Organisation />,
        accessKey: permissionKeys.organisation,
    },
];
